import { useVTApiClient } from './client'
import { useQuery } from '@maui/react-query'

export const useApiKey = (options = {}) => {
  const api = useVTApiClient('auth')
  return useQuery({
    queryFn: () => api.me(),
    queryKey: ['me'],
    select: ({ data }) => data?.attributes?.apikey,
    staleTime: 1000 * 60 * 15,
    ...options
  })
}
